import { statusTextColor } from '@/components/system/colors.ts'

export const markerLabel = (
  text: string,
  status: 'pending' | 'allocated' | 'assigned' | 'onboarded' | 'available' | 'paused' | 'returning' | 'onboardFlagged',
  color = statusTextColor(status)
) =>
  !text
    ? undefined
    : {
        text,
        color,
        fontFamily: 'Inter Variable',
        fontSize: '14',
        fontWeight: '700',
      }
